import React from 'react';
// import BistroMenu from './BistroMenu'
import yohoStyles from './yoho.module.sass';
import FinePrint from './FinePrint'

export default props => {

  const { acf, acfOptions } = props

  return (
    
    <div className={yohoStyles.yoho}>
      <FinePrint
        acf={acf}
        addClasses={yohoStyles.fineprint}
        faq={acfOptions.faq_yoho}
        section="Park Questions"
        show_button
      />
    </div>

  )

};